// Copyright 2021 The Simlin Authors. All rights reserved.
// Use of this source code is governed by the Apache License,
// Version 2.0, that can be found in the LICENSE file.

export const ArrowheadRadius = 6;
export const FlowArrowheadRadius = 8;
export const AuxRadius = 9;
export const CloudRadius = 1.5 * AuxRadius;
export const CloudWidth = 55;
export const ModuleRadius = 5;
export const StraightLineMax = 6; // degrees
